import React, { useEffect } from 'react';
import useForm from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import ScrollToTopPage from '../../components/ScrollToTopPage';
import RoadCareCalculatorContainer from '../../containers/RoadCareCalculatorContainer';
import { calculatorSchema } from '../../validations/contract/roadCare';
import { ROADCARE_CONTRACT_SIGN_PATH } from '../../constants/routes';
import { setRoadCareDetails, getMobileContractData } from '../../redux/modules/roadCareContract';
import { ROADCARE_PREFIX } from '../../constants/roadCare';
import { clearCalculation } from '../../redux/modules/roadCareCalculation';

const RoadCareCalculatorPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const calculationData = useSelector((state) => state.roadCareCalculation);
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const token = urlSearchParams.get('t');

  const formProps = useForm({
    defaultValues: {},
    validationSchema: calculatorSchema,
  });

  useEffect(() => {
    if (token) {
      dispatch(getMobileContractData(token, ROADCARE_PREFIX));
    }
  }, [dispatch, token]);

  useEffect(() => () => {
    dispatch(clearCalculation('calculator'));
  }, [dispatch]);

  const buyButtonHandler = () => {
    dispatch(setRoadCareDetails(calculationData));
    history.push(`${ROADCARE_CONTRACT_SIGN_PATH}/signer`);
  };

  return (
    <>
      <ScrollToTopPage />
      <RoadCareCalculatorContainer
        formProps={formProps}
        buyButtonHandler={buyButtonHandler}
      />
    </>
  );
};

export default RoadCareCalculatorPage;
